import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { TERMINATE_CONTRACT_EARLY } from 'src/store/actions/contractActions';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

const CurrentStep = ({
  activeStep,
  open,
  contract,
  data,
  onNext,
  onBack,
  onSubmit,
  resetRef,
  setData,
  handleClose
}) => {
  const loading = useSelector(
    isLoadingSelector([TERMINATE_CONTRACT_EARLY.action])
  );

  if (data.balance === 0) {
    return (
      <StepTwo
        data={data}
        handleNext={onNext}
        open={open}
        handleBack={onBack}
        resetRef={resetRef}
        handleSubmit={onSubmit}
        loading={loading}
        handleClose={handleClose}
      />
    );
  }

  switch (activeStep) {
    case 0:
      return (
        <StepOne
          open={open}
          data={data}
          contract={contract}
          handleBack={onBack}
          handleNext={onNext}
          resetRef={resetRef}
          setData={setData}
        />
      );
    case 1:
      return (
        <StepTwo
          data={data}
          handleNext={onNext}
          open={open}
          handleBack={onBack}
          resetRef={resetRef}
          handleSubmit={onSubmit}
          loading={loading}
          handleClose={handleClose}
        />
      );
    default:
      return null;
  }
};

CurrentStep.propTypes = {
  activeStep: PropTypes.number.isRequired,
  data: PropTypes.any.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetRef: PropTypes.any.isRequired,
  setData: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  contract: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default CurrentStep;
